import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../utils/axios';
import router from '../router'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || null,
    user: {
      name: null,
      email: null,
      roles: [],
    },
    loadingApp : false,
    showModalUnauthenticated: false,
  },
  mutations: {
    changeValueLoading(state, value){
      state.loadingApp = value;
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    clearAuth(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem('token');
    },
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = null;
    },
    clearAuth(state) {
      state.token = null;
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
    },
    showModalUnauthenticated(state, value){
      state.showModalUnauthenticated = value;
    },
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        // Enviar credenciales al backend
        const responseLogin = await axios.post('/login', credentials);
        // Guardar el token en localStorage
        const token = responseLogin.data.token;
        commit('setToken', token);
        // Configurar el token en Axios para futuras peticiones
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        // Obtener datos del usuario autenticado
        const response = await axios.get('/user');
        // Guardar el usuario en Vuex
        commit('setUser', response.data);
        return response;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    async logout({ commit }) {
      commit('changeValueLoading', true);
      await axios.post('/logout');
      commit('changeValueLoading', false);
      //quitar el token del localStorage
      commit('clearAuth');
      commit('clearUser');
      router.push("/");
      location.reload();
    },
    async checkUser({ commit, state }) {
      if(!state.token) {
        commit('clearUser');
        return
      }
      try {
        commit('changeValueLoading', true);
        const response = await axios.get('/user');
        commit('setUser', response.data);
        commit('changeValueLoading', false);
      } catch {
        commit('changeValueLoading', false);
        commit('clearUser');
      }
    },
  },
  getters: {
    isShowModalUnauthenticated: state => state.showModalUnauthenticated,
    isAuthenticated(state) {
      return !!state.user;
    },
    user(state) {
      return state.user;
    },
    isAdmin(state) {
      return state.user && state.user.roles.length && state.user.roles.some(role => role.id === 1); // 1 es el ID del rol de admin
    },
    getLoadingApp: state => state.loadingApp,
  },
})
